<div class="file-preview-container">
    <iframe *ngIf="safeUrl && isPDF && !isImage" [src]="safeUrl" title="PDF preview"></iframe>
    <div *ngIf="safeUrl && isImage && !isPDF" class="image-preview">
        <div class="image-controls">
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="zoomOut()" aria-label="Zoom out" title="Zoom out">
                <i class="bi bi-zoom-out"></i>
            </button>
            <span class="zoom-level">{{ (zoom * 100) | number:'1.0-0' }}%</span>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="zoomIn()" aria-label="Zoom in" title="Zoom in">
                <i class="bi bi-zoom-in"></i>
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="resetView()" aria-label="Reset" title="Reset to 100%">
                <i class="bi bi-arrow-counterclockwise"></i>
            </button>
        </div>
        <div
            #imageViewport
            class="image-viewport"
            (mousedown)="startPan($event)"
            (mousemove)="onPanMove($event)"
            (mouseup)="endPan()"
            (mouseleave)="endPan()"
            (touchstart)="startPan($event)"
            (touchmove)="onPanMove($event)"
            (touchend)="endPan()"
            [style.cursor]="isPanning ? 'grabbing' : 'grab'">
            <div class="image-canvas" [style.transform]="transform" [style.transform-origin]="'center center'">
                <img [src]="safeUrl" alt="Image preview" (load)="onImageLoad($event)" draggable="false">
            </div>
        </div>
    </div>
    <div class="other-file-preview" *ngIf="!isImage && !isPDF && iconUrl">
        <img [src]="iconUrl" alt="File icon" class="file-icon">
    </div>
</div>
